import React from 'react';
import { Box, Typography, Chip, Paper } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const SuggestedQuestions = ({ questions, onQuestionClick }) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <Paper 
      elevation={1} 
      sx={{ 
        p: 2, 
        borderRadius: 2,
        backgroundColor: 'white'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <HelpOutlineIcon color="primary" sx={{ mr: 1 }} />
        <Typography variant="subtitle1" fontWeight="medium">
          Suggested Questions
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {questions.map((question, index) => (
          <Chip
            key={index}
            label={question}
            onClick={() => onQuestionClick(question)}
            clickable
            color="primary"
            variant="outlined"
            sx={{ 
              borderRadius: 2,
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.08)',
              }
            }}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default SuggestedQuestions;
